import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=364e5fe6&scoped=true"
import script from "@/controllers/notifications.js?vue&type=script&lang=js&external"
export * from "@/controllers/notifications.js?vue&type=script&lang=js&external"
import style0 from "./Notifications.styles.scss?vue&type=style&index=0&id=364e5fe6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e5fe6",
  null
  
)

export default component.exports